export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-24-O-front-WEB-869d50dbe90ce88e7c6f82d81fbf0b63.png";